<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" 
  >
    <path d="M3.7,8.8c0,.1-.1.3-.3.3,0,0,0,0,0,0H.5c-.2,0-.5-.2-.5-.4,0-.2,0-.3.1-.5.5-.6,1.1-1.1,1.8-1.4-1.1-1-1.2-2.7-.2-3.8,1-1.1,2.7-1.2,3.8-.2.4.4.7,1,.8,1.6,0,.1,0,.2-.2.3-1.5.7-2.5,2.2-2.5,3.9,0,0,0,.2,0,.3M15.9,8.2c-.5-.6-1.1-1.1-1.8-1.4,1.1-1,1.2-2.7.2-3.8-1-1.1-2.7-1.2-3.8-.2-.4.4-.7,1-.8,1.6,0,.1,0,.2.2.3,1.5.7,2.5,2.2,2.5,3.9,0,0,0,.2,0,.3,0,.1.1.3.3.3,0,0,0,0,0,0h2.9c.2,0,.5-.2.5-.4,0-.2,0-.3-.1-.5h0ZM9.9,11.1c1.4-1.1,1.7-3.1.6-4.5-1.1-1.4-3.1-1.7-4.5-.6-1.4,1.1-1.7,3.1-.6,4.5.2.2.4.4.6.6-.9.4-1.7,1.1-2.2,2-.1.3,0,.6.2.7,0,0,.2,0,.3,0h7.5c.3,0,.5-.2.5-.5,0,0,0-.2,0-.3-.5-.9-1.3-1.6-2.2-2h0Z"/>
  </svg>
</template>
